import React, { useRef } from "react";
import { getRiskColor } from "../utils/riskUtils";

const ImageUpload = ({ confidence, onAnalyze, analyzing, result }) => {
  const fileInputRef = useRef(null);

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      onAnalyze(file);
    }
  };

  return (
    <div
      style={{
        background: "white",
        borderRadius: "8px",
        padding: "25px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        border: "1px solid #e9ecef",
      }}
    >
      <h3
        style={{
          color: "#2c3e50",
          marginBottom: "20px",
          fontSize: "1.3rem",
          fontWeight: "500",
        }}
      >
        📸 Single Image Analysis
      </h3>

      <div
        onClick={() => !analyzing && fileInputRef.current?.click()}
        style={{
          border: "2px dashed #ccc",
          borderRadius: "6px",
          padding: "40px",
          textAlign: "center",
          cursor: analyzing ? "not-allowed" : "pointer",
          background: analyzing ? "#f0f0f0" : "#fafafa",
          transition: "all 0.2s",
          opacity: analyzing ? 0.6 : 1,
        }}
        onMouseOver={(e) => {
          if (!analyzing) {
            e.currentTarget.style.borderColor = "#4a90e2";
            e.currentTarget.style.background = "#f0f8ff";
          }
        }}
        onMouseOut={(e) => {
          if (!analyzing) {
            e.currentTarget.style.borderColor = "#ccc";
            e.currentTarget.style.background = "#fafafa";
          }
        }}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleFileSelect}
          style={{ display: "none" }}
          disabled={analyzing}
        />
        <div style={{ fontSize: "2rem", marginBottom: "10px" }}>
          {analyzing ? "⏳" : "📁"}
        </div>
        <p>
          {analyzing
            ? "Analyzing image..."
            : "Click to upload medical image for analysis"}
        </p>
        <p style={{ fontSize: "0.9rem", color: "#999", marginTop: "8px" }}>
          Supports JPG, PNG, JPEG • Max size: 10MB
        </p>
      </div>

      {result && (
        <div style={{ marginTop: "20px" }}>
          <h4 style={{ marginBottom: "15px", color: "#2c3e50" }}>
            Analysis Result:
          </h4>
          {result.annotated_image && (
            <img
              src={`data:image/jpeg;base64,${result.annotated_image}`}
              alt="Analyzed"
              style={{
                maxWidth: "100%",
                borderRadius: "6px",
                marginBottom: "15px",
                border: "1px solid #ddd",
              }}
            />
          )}
          <div>
            <h4 style={{ marginBottom: "10px" }}>
              Found {result.detection_count} detection(s):
            </h4>
            {result.detections && result.detections.length > 0 ? (
              result.detections.map((detection, index) => (
                <div
                  key={index}
                  style={{
                    background: "white",
                    border: "1px solid #e9ecef",
                    borderLeft: `4px solid ${getRiskColor(
                      detection.risk_level
                    )}`,
                    padding: "15px",
                    margin: "10px 0",
                    borderRadius: "4px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "8px",
                    }}
                  >
                    <span style={{ fontWeight: "600", color: "#2c3e50" }}>
                      {detection.class_name}
                    </span>
                    <span style={{ color: "#666", fontSize: "0.9rem" }}>
                      {(detection.confidence * 100).toFixed(1)}%
                    </span>
                  </div>
                  <span
                    style={{
                      padding: "2px 8px",
                      borderRadius: "12px",
                      fontSize: "0.75rem",
                      fontWeight: "600",
                      textTransform: "uppercase",
                      background: getRiskColor(detection.risk_level),
                      color: "white",
                    }}
                  >
                    {detection.risk_level}
                  </span>
                </div>
              ))
            ) : (
              <p style={{ color: "#666", fontStyle: "italic" }}>
                No significant findings detected.
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageUpload;
